module.exports = __webpack_public_path__ + "people.c5fbb10478412448e8c3.png";


//////////////////
// WEBPACK FOOTER
// C:/NightKey/CMS/nightkey-cms/src/assets/img/people.png
// module id = ../../../../../src/assets/img/people.png
// module chunks = main